<div class="preview-modal" (click)="onBackdropClick($event)">
  <div class="preview-container">
    <!-- Header -->
    <div class="preview-header">
      <div class="document-info">
        <i class="fa-solid fa-file-lines"></i>
        <span class="document-name">{{ document.storedFileName }}</span>
      </div>

      <div class="header-actions">
        <button
          type="button"
          class="action-btn download-btn"
          [title]="'documents.download' | translate"
          (click)="onDownload()"
        >
          <i class="fa-solid fa-download"></i>
          <span>{{ "documents.download" | translate }}</span>
        </button>
        <button
          type="button"
          class="action-btn close-btn"
          [title]="'close' | translate"
          (click)="onClose()"
        >
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
    </div>

    <!-- Content -->
    <div class="preview-content">
      <!-- Loading State -->
      <div *ngIf="isLoading" class="loading-state">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">{{ "loading" | translate }}...</span>
        </div>
      </div>

      <!-- Error State -->
      <div *ngIf="hasError && !isLoading" class="error-state">
        <i class="fa-solid fa-triangle-exclamation"></i>
        <p>{{ "documents.previewError" | translate }}</p>
      </div>

      <!-- PDF Preview -->
      <iframe
        *ngIf="!isLoading && !hasError && isPdf && previewUrl"
        [src]="previewUrl"
        class="pdf-viewer"
        frameborder="0"
      >
      </iframe>

      <!-- Image Preview -->
      <img
        *ngIf="!isLoading && !hasError && isImage && previewUrl"
        [src]="previewUrl"
        [alt]="document.originalFileName"
        class="image-viewer"
      />

      <!-- Word / No Preview -->
      <div
        *ngIf="!isLoading && !hasError && !isPdf && !isImage"
        class="no-preview-state"
      >
        <i class="fa-solid fa-file-word" *ngIf="isWord"></i>
        <i class="fa-solid fa-file" *ngIf="!isWord"></i>
        <p>{{ "documents.noPreview" | translate }}</p>
        <button type="button" class="btn btn-primary" (click)="onDownload()">
          <i class="fa-solid fa-download"></i>
          {{ "documents.download" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
